module.exports = __webpack_public_path__ + "static/media/icon.5d2844c2.svg";